import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PersonalVerificationDocument, PersonalVerificationMethod, Status } from '../types/personalVerification';

interface PersonalVerificationState {
    verifications: Array<{
        id: string;
        publicId: string;
        personalVerificationMethod: PersonalVerificationMethod;
        personalVerificationDocument: PersonalVerificationDocument;
        receivedDate: string;
        verificationDate: string;
        updateDate: string;
        status: Status;
    }>;
    selectedPage: number;
    totalPage: number;
    selectedIndex: number | null;
}

const initialState: PersonalVerificationState = {
    verifications: [
        // {
        //     id: 'xnjko9639742294',
        //     public_id: 'w7ehrqc6-p1f4-q0wq-ij6jbdeepq',
        //     personal_verification_method: PersonalVerificationMethod.wa,
        //     personal_verification_document: PersonalVerificationDocument.my_number_card,
        //     received_date: '2024/10/08 12:12',
        //     verification_date: '2024/10/08 17:42',
        //     update_date: '2024/10/08 17:42',
        //     status: Status.approved
        // },
        // {
        //     id: 'qwvfn5362356781',
        //     public_id: 'w7ehrqc6-p1f4-q0wq-ij6jbdeepq',
        //     personal_verification_method: PersonalVerificationMethod.wa,
        //     personal_verification_document: PersonalVerificationDocument.my_number_card,
        //     received_date: '2024/10/08 12:12',
        //     verification_date: '2024/10/08 17:42',
        //     update_date: '2024/10/08 17:42',
        //     status: Status.inprogress
        // },
        // {
        //     id: 'echjx2741923299',
        //     public_id: 'w7ehrqc6-p1f4-q0wq-ij6jbdeepq',
        //     personal_verification_method: PersonalVerificationMethod.wa,
        //     personal_verification_document: PersonalVerificationDocument.my_number_card,
        //     received_date: '2024/10/08 12:12',
        //     verification_date: '2024/10/08 17:42',
        //     update_date: '2024/10/08 17:42',
        //     status: Status.approved
        // },{
        //     id: 'echjx2741923299',
        //     public_id: 'w7ehrqc6-p1f4-q0wq-ij6jbdeepq',
        //     personal_verification_method: PersonalVerificationMethod.wa,
        //     personal_verification_document: PersonalVerificationDocument.my_number_card,
        //     received_date: '2024/10/08 12:12',
        //     verification_date: '2024/10/08 17:42',
        //     update_date: '2024/10/08 17:42',
        //     status: Status.approved
        // },{
        //     id: 'echjx2741923299',
        //     public_id: 'w7ehrqc6-p1f4-q0wq-ij6jbdeepq',
        //     personal_verification_method: PersonalVerificationMethod.wa,
        //     personal_verification_document: PersonalVerificationDocument.my_number_card,
        //     received_date: '2024/10/08 12:12',
        //     verification_date: '2024/10/08 17:42',
        //     update_date: '2024/10/08 17:42',
        //     status: Status.approved
        // },{
        //     id: 'echjx2741923299',
        //     public_id: 'w7ehrqc6-p1f4-q0wq-ij6jbdeepq',
        //     personal_verification_method: PersonalVerificationMethod.wa,
        //     personal_verification_document: PersonalVerificationDocument.my_number_card,
        //     received_date: '2024/10/08 12:12',
        //     verification_date: '2024/10/08 17:42',
        //     update_date: '2024/10/08 17:42',
        //     status: Status.approved
        // },
    ],
    selectedPage: 1,
    totalPage: 8,
    selectedIndex: null
};

const personalVerificationSlice = createSlice({
    name: 'personalVerification',
    initialState,
    reducers: {
        setPersonalVerificationData: (state, action: PayloadAction<any>) => {
            state.verifications = action.payload;
        },
        setSelectedIndex: (state, action: PayloadAction<number | null>) => {
            state.selectedIndex = action.payload;
        },
        handlePrevPage: (state) => {
            state.selectedPage = state.selectedPage - 1 < 1 ? 1 : state.selectedPage - 1;
        },
        handleNextPage: (state) => {
            state.selectedPage = state.selectedPage + 1 > state.totalPage ? state.totalPage : state.selectedPage + 1;
        }
    },
});

export const { setSelectedIndex, handlePrevPage, handleNextPage, setPersonalVerificationData } = personalVerificationSlice.actions;

export default personalVerificationSlice.reducer;